module.exports = __webpack_public_path__ + "img/img.7fc52411.jpg";